const cache = new Map<string, Intl.NumberFormat>()

export const formatNumber = (
  value: number,
  options?: Intl.NumberFormatOptions,
) => {
  const key = options ? JSON.stringify(options) : ''
  let formatter = cache.get(key)
  if (!formatter) {
    formatter = new Intl.NumberFormat('de-DE', options)
    cache.set(key, formatter)
  }
  return formatter.format(value)
}
